import React, {useContext, useEffect} from "react"
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import {CartDetailContext} from "./context/CartDetailContext";
import {getDocumentURL} from "../handler/ParentDataHandler";
import {getBaseUrl, getRefreshInterval} from "../util/Util";
import {FormattedMessage} from "react-intl";
import {CapabilityContext} from "../global/context/CapabilityContext";

const CartInfo = (props) => {
    const {configViewModel} = useContext(CapabilityContext);
    const {dispatch} = useContext(CartDetailContext)

    const getPhoneToolLink = () => {
        const alias = props.cart.associate;
        return alias.includes('@') ?
            "https://phonetool.amazon.com/users/" + alias.split("@")[0] :
            "#"
    }

    const getCartData = () => {
        getDocumentURL().then(result => {
            dispatch({type: 'LOAD_VIEW', data: {
                    routeId: props.cart.routeId,
                    cartId: props.cart.cartId,
                    stationCode: props.cart.stationCode,
                    dispatcher: dispatch,
                    baseUrl: getBaseUrl(result),
                    stationConfig: configViewModel.stationConfig
                }
            });
        })
    }

    useEffect(() => {
        getCartData();
        const interval = setInterval(() => {
            getCartData();
        }, getRefreshInterval())
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <Row widths="100%" spacingInset="large large small">
                <BreadcrumbGroup>
                    <Breadcrumb href="#stage">
                       <FormattedMessage id="cartInfo.stage" defaultMessage="Stage"/>
                    </Breadcrumb>
                    <Breadcrumb>
                        <FormattedMessage id="cartInfo.cartDetail" defaultMessage="Cart Details"/>
                    </Breadcrumb>
                </BreadcrumbGroup>
            </Row>
            <Row widths="100%" spacingInset="small large small">
                <Heading level={3} type="h600" alignment="left">{props.cart.cartId}</Heading>
            </Row>
            <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium large none large">
                <Text type="h100">
                    <FormattedMessage id="cartInfo.status" defaultMessage="Status"/>
                </Text>
                <Text type="b200">{props.cart.status}</Text>
            </Row>
            <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium large none large">
                <Text type="h100">
                    <FormattedMessage id="cartInfo.location" defaultMessage="Location"/>
                </Text>
                <Text type="b200">{props.cart.location}</Text>
            </Row>
            <Row widths={["grid-2", "grid-10"]} alignmentVertical="top" spacingInset="medium large none large">
                <Text type="h100">
                    <FormattedMessage id="cartInfo.associate" defaultMessage="Associate"/>
                </Text>
                {props.cart.associate !== '...' ?
                    <Link href={getPhoneToolLink()} type="secondary" target="_blank" rel="noreferrer noopener">
                        {props.cart.associate}
                    </Link>
                    : '...'
                }
            </Row>
        </div>
    );
}

export default CartInfo


// WEBPACK FOOTER //
// ./src/components/cartDrillDown/CartInfo.js